/* Haye Nii (task 38): keep the SmartBot chat quiet on every page.
   After a shopper writes a message and minimises the chat, SmartBot pops a big coloured message card
   ("Hi, welcome to Haye Nii...") over the products. That card lives inside the app's own (shadow) box, so the
   theme's CSS can't reach it: this adds one small style there that hides only that card. The round chat
   button, its red unread number and the chat window itself work as before.
   To undo: remove this file's <script> line in layout/theme.liquid. */
(function () {
  var CSS = '[class*="_notification-card_"]{display:none !important;}';
  var tries = 0;

  function calm() {
    var host = document.getElementById('smart-bot-container');
    var root = host && host.shadowRoot;
    if (!root) return false;
    if (!root.getElementById('hn-calm-chat')) {
      var style = document.createElement('style');
      style.id = 'hn-calm-chat';
      style.textContent = CSS;
      root.appendChild(style);
    }
    return true;
  }

  // The chat app loads a few seconds after the page
  var timer = setInterval(function () {
    tries++;
    if (calm() || tries > 30) clearInterval(timer);
  }, 1000);
})();
